import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createMarkup from '../../helpers/createMarkup';
import FeedImageLightbox from './FeedImageLightbox';
import { CardBody } from 'reactstrap';
import { useSelector } from 'react-redux';

const FeedCardContent = ({ description, files, feedEvent }) => {
  const { token } = useSelector(state => state.auth.user);

  const [images] = useState(
    Array.isArray(files)
      ? files.filter(f => f && typeof f === 'object' && f.file).map(({ file }) => `${file}`)
      : []
  );

  return <CardBody className={classNames({ 'p-0': !!feedEvent })}>
    {images.length > 0 && <FeedImageLightbox images={images} />}
    {!!description && <p className='p-2 px-3 mb-3 mt-2' dangerouslySetInnerHTML={createMarkup(description)} />}
  </CardBody>
};

FeedCardContent.propTypes = {
  description: PropTypes.string,
  feedEvent: PropTypes.object,
  files: PropTypes.array.isRequired,
};

export default FeedCardContent;